import React from 'react';
import { Input } from 'antd';

/** Weight entry as digit string → displayed as kg with 2 decimals (e.g. 3050 → 30.50). */
export default function WeightMinorUnitsInput({ value, onChange, ...props }) {
  const [digits, setDigits] = React.useState('');

  React.useEffect(() => {
    if (value == null || value === '') {
      setDigits('');
    } else {
      const n = Number(value);
      if (!Number.isNaN(n)) {
        setDigits(String(Math.round(n * 100)));
      }
    }
  }, [value]);

  const handleChange = (e) => {
    const raw = e.target.value.replace(/\D/g, '');
    setDigits(raw);
    if (raw === '') {
      onChange?.(undefined);
    } else {
      onChange?.(Number(raw) / 100);
    }
  };

  const display =
    digits === '' ? '' : (Number(digits) / 100).toFixed(2);

  return (
    <Input
      {...props}
      inputMode="numeric"
      autoComplete="off"
      value={display}
      onChange={handleChange}
    />
  );
}